import { render, staticRenderFns } from "./SgsTop.vue?vue&type=template&id=1c07ddf4&scoped=true"
import script from "./SgsTop.vue?vue&type=script&lang=js"
export * from "./SgsTop.vue?vue&type=script&lang=js"
import style0 from "./SgsTop.vue?vue&type=style&index=0&id=1c07ddf4&prod&lang=scss&scoped=true"
import style1 from "./SgsTop.vue?vue&type=style&index=1&id=1c07ddf4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c07ddf4",
  null
  
)

export default component.exports